import { Id } from '@nextforce/api'
import { SettingsSource } from './types'

const keys = {
  all: ['settings'],
  user: () => [...keys.all, 'user'],
  store: (storeId: Id) => [...keys.all, 'stores', storeId],
  storePreference: (storeId: Id) => [...keys.all, 'store_preferences', storeId],
}

export function getKey(source: SettingsSource) {
  switch (source.type) {
    case 'user':
      return keys.user()
    case 'store':
      return source.storeId ? keys.store(source.storeId) : []
    case 'store_preferences':
      return source.storeId ? keys.storePreference(source.storeId) : []
  }
}

export default keys
